import {Component, OnDestroy, OnInit, Signal} from "@angular/core";
import {CoreController, MK_CORE} from "../_controllers/core.controller";
import {CoreModel} from "../_models/core.model";
import {AuthenticationService} from "../../common/services/authentication.service";
import {BuildInfoRepository} from "../../common/repositories/build-info.repository";

@Component({
  selector: "link-core-view",
  templateUrl: "./core.view.html",
  styleUrls: ["./core.view.scss"],
  providers: [
    CoreController,
    AuthenticationService,
    BuildInfoRepository,
  ]
})
export class CoreView implements OnInit, OnDestroy {

  protected model: CoreModel;

  constructor(private controller: CoreController) {
    this.model = this.controller.getModel(MK_CORE);
  }

  ngOnInit() {
    this.controller.handle('Init', {});
  }

  ngOnDestroy() {

  }

  protected mobileNavigationActivation(): void {
    this.controller.handle('MobileNavigationActivation', {});
  }

  protected mobileNavigationDeactivation(): void {
    this.controller.handle('MobileNavigationDeactivation', {});
  }

  protected navigationPinToggle(): void {
    this.controller.handle('NavigationPinToggle', {});
  }

  protected navigationMouseEnter(): void {
    this.controller.handle('NavigationMouseEnter', {});
  }

  protected navigationMouseLeave(): void {
    this.controller.handle('NavigationMouseLeave', {});
  }

  protected updateNowClicked(): void {
    this.controller.handle('UpdateAppVersion', {});
  }

  protected snoozeClicked(): void {
    this.controller.handle('SnoozeUpdateAppVersion', {});
  }
}
